import CountUp from "../countup";

jQuery(document).ready(function ($) {
    $.getJSON(window.location.href, { action: 'load_alerts' }, function (response) {
        if (response.items.length) {
            // console.log( response.items.length + " alerts found." );

            var $container = $("<div id='proof' class='proof-hidden' ><div id='proof-image' ></div><div id='proof-content' ><div id='proof-title' ></div><div id='proof-text' ></div><div id='proof-time' ></div><div id='proof-wc-verified' ></div><div id='proof-optimizecheckouts-verified' ></div><div id='proof-optimizepress-verified' ></div></div></div>"),
                current_item_index = null,
                current_item = null,
                openingTimeout = null,
                closingTimeout = null,
                first_showing = true;

            $container.addClass('proof-design-' + response.settings.design_type);
            $container.addClass('proof-position-' + response.settings.position);

            if (response.settings.clickable) {
                $container.addClass('proof-clickable');
            }

            if (response.settings.show_time_ago) {
                $container.addClass('proof-show-timeago');
            }

            if (response.settings.show_on_desktop) {
                $container.addClass('proof-desktop');
            }

            if (response.settings.show_on_mobile) {
                $container.addClass('proof-mobile');
            }

            if (response.settings.show_close_button) {
                $container.append("<div id='proof-close' ><i class='fa fa-times' ></i></div>");
            }

            $container.appendTo('body');

            var showNextProof = function () {
                if (first_showing) {
                    current_item_index = 0;
                } else {
                    current_item_index++;
                }

                if (current_item_index > response.items.length - 1) {
                    if (response.settings.loop) {
                        current_item_index = 0;
                    } else {
                        return;
                    }
                }
                current_item = response.items[current_item_index];

                $('<img>').attr('src', current_item.image);

                clearTimeout(openingTimeout);
                clearTimeout(closingTimeout);

                openingTimeout = setTimeout(
                    function () {
                        if (current_item.image) {
                            $('#proof-image')
                                .empty()
                                .css('background-image', 'url(' + current_item.image + ')');
                        } else {
                            $("<i class='fa'>")
                                .addClass(current_item.icon)
                                .css({
                                    background: current_item.icon_background_color,
                                    color: current_item.icon_color,
                                })
                                .appendTo($('#proof-image').empty().css('background-image', 'none'));
                        }

                        $('#proof-title').html(current_item.title).attr('title', current_item.title);
                        $('#proof-text').html(current_item.content).attr('title', current_item.content);

                        if (response.settings.show_time_ago) {
                            $('#proof-time').html(current_item.time);
                        }

                        if (current_item.visitors_count) {
                            $('#proof-title').remove();
                            $('#proof-time').remove();
                            $('#proof-text').replaceWith('<div id="visitor-text">' + current_item.content + '</div>');

                            console.log(current_item.visitors_count);

                            var options = {
                                useEasing: true,
                                useGrouping: true,
                                separator: ',',
                                decimal: '.',
                            };

                            console.log(options);
                            console.log(CountUp);

                            var noVisitors = parseInt(current_item.noVisitors);
                            var count = new CountUp('visitors-count', 0, noVisitors, 0, 5, options);
                            if (!count.error) {
                                count.start();
                            } else {
                                console.error(count.error);
                            }
                        }

                        if (response.settings.wc_verified == 1 && response.data.type === 'woocommerce') {
                            $('#proof-wc-verified').html('<i class="fa fa-check wc_verified-icon"></i>').append(op_urgency_tr.wp_verified);
                        }
                        if (response.settings.optimizecheckouts_verified == 1 && response.data.type === 'optimizecheckouts') {
                            $('#proof-optimizecheckouts-verified').html('<i class="fa fa-check optimizecheckouts_verified-icon"></i>').append(op_urgency_tr.optimizecheckouts_verified);
                        }
                        if (response.settings.optimizepress_verified == 1 && response.data.type === 'optimizesubscriber') {
                            $('#proof-optimizepress-verified').html('<i class="fa fa-check optimizepress_verified-icon"></i>').append(op_urgency_tr.optimizepress_verified);
                        }
                        $('#proof').removeClass('proof-hidden').addClass('proof-displayed');

                        closingTimeout = setTimeout(function () {
                            closeProof();
                        }, response.settings.duration * 1000);
                    },
                    (first_showing ? response.settings.delay : response.settings.interval) * 1000,
                );

                if (first_showing) {
                    first_showing = false;
                }
            };

            var closeProof = function () {
                $('#proof').removeClass('proof-displayed');
                $('#proof').addClass('proof-hidden');
                showNextProof();
            };

            $('#proof-close').on('click', function (e) {
                e.stopPropagation();
                closeProof();
            });

            $container.on('click', function (e) {
                if (current_item.link) {
                    window.open(current_item.link);
                }
            });

            showNextProof();
        } else {
            // console.log('No alerts found.');
        }
    });
});
